import React from "react";
import styled from "styled-components";
import Box from "../Box/Box";
import IconSvg from "../IconSvg/IconSvg";
import HeaderProfile from "../HeaderProfile/HeaderProfile";

const ActiveAbleButton = styled.a`
  padding: 0.5em;
  color: #1F2029;
  font-weight: bold;
  margin-right: 1.25em;
  border-radius: 0.25em;

  ${({ active })=> active && `
    background: #E8EAFD;
    color: #5159C9;
  `}
`;

const Container = styled(Box)`
  border-bottom: #E4E4ED;
  border-bottom-style: solid;
  border-bottom-width: 1px;
`;

const PageHeader = ({name}) => (
  <Container bgColor='#FFFFFF' flex justifyContent='space-between' spacing='p-5' alignItems='end'>
    <Box flex>
      <IconSvg icon='thrivecoin-logo' spacing='mr-4'></IconSvg>
      <ActiveAbleButton active>Manage</ActiveAbleButton>
      <ActiveAbleButton>Explore</ActiveAbleButton>
      <ActiveAbleButton>Community</ActiveAbleButton>
      <ActiveAbleButton>Support</ActiveAbleButton>
    </Box>
    <HeaderProfile name={name}/>
  </Container>
);

PageHeader.defaultProps = {
  name: "Jonathan Doe"
};

export default PageHeader;

